export default () => {
  let favicons = document.querySelectorAll('link[href="/favicon.ico"]');
  favicons.forEach((favicon) => {
    favicon.parentNode.removeChild(favicon);
  });
  let favicon = favicons[0];
  favicon.rel = 'icon';
  const base = process.env.NODE_ENV === 'production' ? "" : process.env.VUE_APP_IMG;
  const companyPicPath = base + "/company/images/";
  favicon.href = `${companyPicPath}company_favicon.ico?t=${new Date().getTime()}`;
  document.getElementsByTagName('head')[0].appendChild(favicon);
}